import { IWidgetCollection, IWidgetGroup } from "@src/interface/Widget";
import React, { ReactNode, useMemo } from "react";
import WidgetLayout from "../WidgetLayout/WidgetLayout";
import "./WidgetCollection.styles.scss";
import clsx from "clsx";

interface ICollectionListProps {
  children?: ReactNode;
  list: Array<Partial<IWidgetCollection> | null>;
  group: Partial<IWidgetGroup>;
  partialLoad?: boolean;
}

const WidgetCollection = (props: ICollectionListProps) => {
  const { list: rawlist, group, partialLoad } = props;
  const { use_container } = group;
  const { heading_h1, is_page } = group;

  const list = useMemo(() => {
    const _list: Partial<IWidgetCollection & { loadIndex?: number }>[] = [];

    rawlist.forEach((item, i) => {
      if (item) {
        let _loadIndex = 1;

        if (_list[i - 1]) {
          _loadIndex = _list[i - 1].loadIndex || 1;
        }
        _list.push({ ...item, loadIndex: _loadIndex });
      }
    });
    return _list;
  }, [rawlist]);

  return (
    <div
      className={clsx({
        "collection-container": !!use_container,
        "widget-collection": true,
        "is-page": is_page,
      })}
    >
      {heading_h1 ? <h1 style={{ display: "none" }}>{heading_h1}</h1> : null}
      {list.map((collection, i) => {
        return (
          <WidgetLayout
            key={collection.id + "-" + i}
            // @ts-ignore
            list={collection.layout_list || []}
            collectionPosition={i + 1}
            group={group}
            index={i}
            loadIndexStart={partialLoad ? collection.loadIndex : undefined}
          />
        );
      })}
    </div>
  );
};

export default WidgetCollection;
